import React__default from 'react';
import PropTypes from 'prop-types';
import { brands, verticalSpacingSizes } from '../../tools/constants.js';

var propTypes = {
  children: PropTypes.node.isRequired,
  align: PropTypes.oneOf(['', 'left', 'center', 'right']),
  brand: PropTypes.oneOf(brands),
  hasNoTextTransform: PropTypes.bool,
  highlighted: PropTypes.oneOf(['', true, 'style-1', 'style-2', 'style-3', 'style-4', 'style-5']),
  marginBottom: PropTypes.oneOf(verticalSpacingSizes),
  marginTop: PropTypes.oneOf(verticalSpacingSizes),
  paddingTop: PropTypes.oneOf(verticalSpacingSizes),
  size: PropTypes.oneOf(['', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 5, 10, 15, 18, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100]),
  theme: PropTypes.oneOf(['default', 'inverse', 'core-category-1', 'core-category-1-inverse', 'core-category-2', 'core-category-2-inverse', 'pride', 'pride-inverse', 'seasonal', 'seasonal-inverse', 'loyalty-inverse', 'loyalty']),
  variant: PropTypes.oneOf(['', 'lead-in', 'subhead', 'subcopy'])
};
function Headline(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? null : _ref$align,
    _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? null : _ref$brand,
    children = _ref.children,
    _ref$hasNoTextTransfo = _ref.hasNoTextTransform,
    hasNoTextTransform = _ref$hasNoTextTransfo === void 0 ? false : _ref$hasNoTextTransfo,
    _ref$highlighted = _ref.highlighted,
    highlighted = _ref$highlighted === void 0 ? null : _ref$highlighted,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? null : _ref$marginBottom,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? null : _ref$marginTop,
    _ref$paddingTop = _ref.paddingTop,
    paddingTop = _ref$paddingTop === void 0 ? null : _ref$paddingTop,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? null : _ref$size,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'default' : _ref$theme,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? null : _ref$variant;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "headline",
    "data-align": align,
    "data-brand": brand,
    "data-highlighted": highlighted,
    "data-margin-bottom": marginBottom,
    "data-margin-top": marginTop,
    "data-no-text-transform": hasNoTextTransform,
    "data-padding-top": paddingTop,
    "data-size": size,
    "data-theme": theme,
    "data-variant": variant
  }, children);
}
Headline.propTypes = propTypes;

export { Headline as default };
//# sourceMappingURL=Headline.js.map
